// Generic Labels
export const LABEL_SEARCH_TERM = "Search Term";
export const LABEL_STATUS = "Status";
export const LABEL_CANCEL = "Cancel";
export const LABEL_NEXT = "Next";
export const LABEL_SAVE = "Save";
export const LABEL_VIEW_DETAILS = "View Details";
export const LABEL_SAVE_AND_CLOSE = "Save & Close";
export const LABEL_SAVE_AND_CONTINUE = "Save & New";
export const LABEL_YES = "Yes";
export const LABEL_NO = "No";
export const LABEL_FORM_TYPE = "Form Type";
export const LABEL_PRODUCTS = "Products";
export const LABEL_BRANCHES = "Branches";
export const LABEL_OPPORTUNITY_ID = "Opportunity Id";
export const LABEL_FROM_DATE = "From Date";
export const LABEL_TO_DATE = "To Date";
export const LABEL_SAVE_DRAFT = "Save as Draft";
export const LABEL_SAVE_AND_SYNC_DRAFT = "Submit";
export const LABEL_ACTIONS = "Actions";
export const LABEL_ACTIVATE = "Activate";
export const LABEL_DEACTIVATE = "Deactivate";
export const LABEL_EDIT = "Edit";
export const LABEL_EDIT_OBJECT = "Edit {0}";
export const LABEL_DATE = "Date";

export const LABEL_RECORD_SAVED_SUCCESSFULLY = "Record Saved successfully.";

export const LABEL_NAME = "Name";
export const LABEL_DESCRIPTION = "Description";
export const LABEL_VALUE = "Value";
export const LABEL_EMPLOYEE_NUMBER = "Employee Number";
export const LABEL_EMAIL = "Email";
export const LABEL_JOB_TITLE = "Job Title";
export const LABEL_SUPERVISOR_EMAIL = "Supervisor Email";
export const LABEL_HIRE_DATE = "Hire Date";
export const LABEL_RECORD_STATUS = "Record Status";
export const LABEL_EMPLOYEE_STATUS = "Employment Status";
export const LABEL_ENTITY = "Entity";
export const LABEL_TERRITORY = "Territory";
export const LABEL_USERNAME = "Username";
export const LABEL_ID = "Id";
export const LABEL_COUNTRY = "Country";
export const LABEL_LOCATION = "Branch";
export const LABEL_DEPARTMENT = "Department";
export const LABEL_FUNCTION = "Function";
export const LABEL_LAST_LOGIN_DATE = "Last Login Date and Time";
export const LABEL_ROLES = "Roles";
export const LABEL_USERS = "Users";
export const LABEL_OBJECT_SAVED_SUCCESSFULLY = "The {0} was saved successfully";

// Wallet Labels
export const LABEL_WALLET = "Wallet";
export const LABEL_DEPOSIT = "Deposit";
export const LABEL_BALANCE = "Balance";
export const LABEL_TRANSACTION_REFERENCE = "Transaction Reference";
export const LABEL_PAYMENT_MODE = "Payment Mode";
export const LABEL_MINIMUM_DEPOSIT = "Minimum Deposit";

// Backoffice Labels
export const TITLE_DEACTIVATE_ROLE = "Deactivate Role";
export const TITLE_ACTIVATE_ROLE = "Activate Role";
export const TITLE_USER_DETAILS = "User Details for {0}";
export const TITLE_USER_ROLES = "User Roles for {0}";
export const LABEL_DEACTIVATE_ROLE_CONFIRMATION =
  "Are you sure you want to deactivate this role?";
export const LABEL_ACTIVATE_ROLE_CONFIRMATION =
  "Are you sure you want to activate this role?";
export const LABEL_EDIT_ROLES = "Edit Roles";
export const LABEL_SYNC_USERS = "Sync Users from EPT Sheet";

//Member Constants
export const FULL_NAME_LABEL = "Full Name";
export const FIRST_NAME_LABEL = "First Name";
export const LAST_NAME_LABEL = "Last Name";
export const SALUTATION_LABEL = "Salutation";
export const GENDER_LABEL = "Gender";
export const MIDDLE_NAME_LABEL = "Middle Name";
export const PHYSICAL_ADDRESS_LABEL = "Physical Address";
export const PHONE_NUMBER_LABEL = "Phone Number";
export const EMAIL_ADDRESS_LABEL = "Email Address";
export const YEAR_JOINED_LABEL = "Year Joined";
export const OCCUPATION_LABEL = "Occupation";
export const NIN_LABEL = "NIN";
export const IMAGE_URL_LABEL = "Image URL";
